import React, { useEffect, useState } from 'react';
import {Link, useParams, useNavigate} from 'react-router-dom';
import { toast } from "react-toastify";
import AdminCashierAPI from "../../../../apis/adminApi/AdminCashierAPI";
import FormContentLoader from "../../../loaders/FormContentLoader";
import Field from "../../../forms/Field";
import MyButton from "../../../assets/MyButton";
import {useForm} from "react-hook-form";

const AdminEditCompte = () => {

    const { formState } = useForm();
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [loading, setLoading] = useState(true);
    let {compteId} = useParams();

    const [showLoader, setShowLoader] = useState(false);

    const [compte, setCompte] = useState({
        compte : "", code: "", id: compteId
    });

    const [editing, setEditing] = useState(false);

    const [errors, setErrors] = useState({
        compte : "", code: ""
    });


    //Recuperation d'une facture
    const fetchCompte = async id => {
        try{
            const { compte, code, id } = await AdminCashierAPI.findOneCompte(compteId);
            setCompte({ compte, code, id });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger le compte caisse démandée !");
            navigate("/admin/cashier/comptes");
        }
    };


    useEffect(() => {
        setEditing(true);
        fetchCompte(compteId);
    }, [compteId]);


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCompte({...compte, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await AdminCashierAPI.storeComptes(compte);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Compte source modifié avec succès");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification !");
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-7">
                    {loading && <FormContentLoader />}

                    {!loading && <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Modifier un compte source</h5>
                                        <div className="row">
                                            <div className="col-6">
                                                <Field
                                                    name="compte"
                                                    error={errors.compte}
                                                    value={compte.compte}
                                                    onChange={handleChange}
                                                    label="Nom du compte caisse"
                                                    placeholder="Nom"
                                                />
                                            </div>

                                            <div className="col-6">
                                                <Field
                                                    name="code"
                                                    error={errors.code}
                                                    value={compte.code}
                                                    onChange={handleChange}
                                                    label="Code"
                                                    placeholder="code"
                                                />
                                            </div>
                                        </div>

                                        <MyButton
                                            text="Modifier"
                                            onSubmit={handleSubmit}
                                            loading={showLoader}
                                            disabled={showLoader}
                                        />
                                        <Link to="/admin/cashier/comptes" className="btn btn-info mx-2">Revenir aux compte caise</Link>
                                    </div>
                                </div>
                            </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default AdminEditCompte;
